export default "__VITE_ASSET__f065f6f6__"